import { registerPlugin, type PluginListenerHandle } from '@capacitor/core';

export interface DownloadProgress {
  received: number;
  total: number;
}

interface AppUpdaterPlugin {
  canInstall(): Promise<{ allowed: boolean }>;
  requestInstallPermission(): Promise<void>;
  downloadAndInstall(options: { url: string }): Promise<{ bytes: number }>;
  /** Opens the installer again on the file already downloaded. */
  installDownloaded(): Promise<void>;
  addListener(eventName: 'downloadProgress', listener: (progress: DownloadProgress) => void): Promise<PluginListenerHandle>;
}

/** Local Android plugin (AppUpdaterPlugin.java in client/android); only the Android shell implements it. */
export const AppUpdater = registerPlugin<AppUpdaterPlugin>('AppUpdater');
